import { Opportunity } from "@/opportunity/opportunity";
import { Card } from "@/components/ui/card";
import React, { Fragment } from "react";

const OpportunityLearnMoreCard = ({ opportunity }: { opportunity: Opportunity }) => {

  if (!opportunity.category_object.attachments || opportunity.category_object.attachments.length === 0) {
    return;
  }

  return (
    <Card className="p-4 flex flex-col gap-4">
      <h3 className="text-lg font-semibold text-gray-800">
        Learn more
      </h3>
      {
        opportunity.category_object.attachments.map((attachment, index) => (
          <Fragment key={index}>
            <div>
              <h4 className="text-base font-semibold text-gray-800 mb-2">
                {attachment.title}
              </h4>
              {
                attachment.description && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: attachment.description || "",
                    }}
                  />
                )
              }
              {attachment.image_url && (
                <a href={attachment.image_url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={attachment.image_url}
                    alt={attachment.title}
                    className="w-full object-cover rounded-lg lg:max-w-1/2"
                  />
                </a>
              )}
            </div>
            {
              index !== opportunity.category_object.attachments.length - 1 && (
                <hr/>
              )
            }
          </Fragment>
        ))
      }
    </Card>
  )
}

export default OpportunityLearnMoreCard;
